import type { PropsWithChildren } from 'react'
import { useAuthContext } from '@offer/auth-lib'
import { RolesContext } from './RolesContext'
import { RolesWhiteList } from './types'

export function RolesProvider({ children }: Readonly<PropsWithChildren>) {
  const { user } = useAuthContext()
  const userRoles = user?.roles || []
  const isAdmin = userRoles.includes(RolesWhiteList.ADMIN)
  const isProductLeader = userRoles.includes(RolesWhiteList.SPO_PRODUCT_LEADER)
  const isSportLeader = userRoles.includes(
    RolesWhiteList.SPO_INTERNATIONAL_SPORT_LEADER,
  )
  const isViewer = userRoles.includes(RolesWhiteList.SPO_VISUALIZATION)

  return (
    <RolesContext
      value={{
        hasRoleVisualization: isViewer || isAdmin,
        hasRoleProductLeader: isProductLeader || isAdmin,
        hasRoleSportLeader: isSportLeader || isAdmin,
      }}
    >
      {children}
    </RolesContext>
  )
}
